// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"9f81f40168325fd1","3368":"dd32af54eefce42c","3776":"dd32af54eefce42c","4668":"dd32af54eefce42c"}[chunkId] + ".css";
};